import React from 'react';
import { Avatar, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * DbeAvatar — reusable icon avatar for the whole app. Renders an icon on a
 * tinted background derived from `color` (via theme.custom.bgAndColorStyle);
 * optionally tooltipped (tooltip shows on desktop hover).
 *
 *   icon     — node rendered inside (SvgIcons inherit the avatar color)
 *   color    — base hex color; drives the background + icon color
 *   tooltip  — hover text (desktop)
 *   variant  — MUI Avatar variant: 'circular' | 'rounded' | 'square'
 *   size     — width/height in px
 *   sx       — overrides merged onto the Avatar
 */
const DbeAvatar = function DbeAvatar({
  icon = null,
  color,
  tooltip = '',
  variant = 'circular',
  size = 44,
  sx = {},
}) {
  const theme = useTheme();

  const content = (
    <Avatar
      variant={variant}
      sx={{
        width: size,
        height: size,
        flex: 'none',
        ...(color
          ? theme.custom.bgAndColorStyle(color, theme.palette.mode)
          : {}),
        ...sx,
      }}
    >
      {icon}
    </Avatar>
  );

  return tooltip ? (
    <Tooltip title={tooltip} arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default DbeAvatar;
